import { ILogicState } from "./types";
import { handlers } from "./handlers";
import createReducer from "./../createReducer";

export const LogicInitialState: ILogicState = {
    data: {
        rules: [],
    },
};
export default createReducer(LogicInitialState, handlers);
